import Subject from "../cse4sub/Subject";
import React from 'react'
//import csm from '../assets/ASH503mid21.pdf'
import cse from '../assets/ASH503end21.pdf'
export default function Coi() {
  return (
    <div>
       <Subject title="Constitution of India(ASH503)" sub="COI" syllabus="#"
    book1="Madhav Khosla, The Indian Constitution, Oxford University Press. New Delhi, 2012" book2=" "
    book1Link="https://www.pdfdrive.com/download.pdf?id=200795190&h=b858b0a8a4591a555c29c2eb87567e4e&u=cache&ext=pdf" 
    book2Link="#" int21="#" mid21="#" end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}